import React from 'react'
import './footer.css'

const Footer = () => {
  return (
    <div className='space'></div>
  )
}

export default Footer